import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const BankAccountRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--payment-mean--bank-account']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
